import mock from '../mock'

const utilities = {
    tasks: {
        name: 'Task',
        navLink : '/task/view',
        userLabel: 'Customer',
        taskstatus: [
            {
                name: 'Pending',
                id: 1
            },
            {
                name: 'Inprogress',
                id: 2
            },
            {
                name: 'Completed',
                id: 3
            },
            {
                name: 'On Hold',
                id: 4
            },
            {
                name: 'Cancelled',
                id: 5
            },
            {
                name: 'Sent for Review',
                id: 6
            },
            {
                name: 'Request Changes',
                id: 7
            },
            {
                name: 'To Do',
                id: 8
            },
            {
                name: 'Overue',
                id: 9
            }
        ],
        status: [
            {
                name: 'Active',
                id: '1'
            },
            {
                name: 'Deleted',
                id: '-1'
            }
        ]
    },
    taskinvoices: {
        name: 'Invoice',
        userLabel: 'Customer',
        navLink : '/invoice/view',
        paymentstatus: [
            { name: 'Paid', id: 7 },
            { name: 'Partially Paid', id: 6 },
            { name: 'Pending', id: 5 }
        ],
        status: [
            { name: 'Proforma', id: 4 },
            { name: 'Invoice', id: 11 },
            {
                name: 'Deleted',
                id: '-1'
            }
        ]
    },
    taskconversations: {
        name: 'Comment',
        userLabel: 'User',
        navLink : '/task/view',
        status: [
            {
                name: 'Deleted',
                id: '-1'
            }
        ]
    },
    comments: {
        name: 'Comment',
        userLabel: 'User',
        navLink : '/task/view',
        status: [
            {
                name: 'Deleted',
                id: '-1'
            }
        ]
    },
    taskinvoicepayments: {
        name: 'Payments',
        userLabel: 'Customer',
        status: [
            {
                name: 'Deleted',
                id: '-1'
            }
        ]
    },
    taskinvoiceitems: {
        name: 'Invoice',
        navLink : '/invoice/view',
        userLabel: 'Customer',
        status: [
            {
                name: 'Deleted',
                id: '-1'
            }
        ]
    },
    tasktimesheets: {
        name: 'Timesheet',
        navLink : '/task/view',
        userLabel: 'User',
        status: [
            {
                name: 'Deleted',
                id: '-1'
            }
        ]
    },
    employeesleaves: {
        navLink : '/leaves/list',
        name: 'Leaves',
        userLabel: 'User',
        status: [
            {
                name: 'Deleted',
                id: '-1'
            },
            { name: 'Applied', id: 1 },
            { name: 'Approved', id: 2 },
            { name: 'Rejected', id: 3 }
        ]
    },
    employeeattendances: {
        name: 'Attendance',
        navLink : '/attendance/list',
        userLabel: 'User',
        status: [
            {
                name: 'Deleted',
                id: '-1'
            },
            { name: 'Early', id: 1 },
            { name: 'On Time', id: 2 },
            { name: 'Late', id: 3 }
        ]
    }
}

mock.onPost('/api/applications/status').reply(200, utilities)